module.exports = __webpack_public_path__ + "static/dl2-stay-human_banner2-b80b3064129cd7f113fcee3725da5771.jpg";